module.exports = "/../../dist/frontend/images/location-zoe.webp?ea727a886e6f4e18a28403dbf6fb5e3c";